// Wrapper PostHog pour le module devis.
//
// Pilote analytics : on ne capture QUE des événements nommés liés au tunnel de
// devis, avec des properties non-PII (IDs, montants, catégories). Jamais de nom,
// téléphone, email ou IMEI — voir tasks/etude_posthog.md (§ RGPD).
//
// Si REACT_APP_POSTHOG_KEY est absente, le module fonctionne en no-op : aucun
// appel réseau, aucune dépendance bloquante. Permet de livrer le code avant
// d'avoir la clé.

import posthog from 'posthog-js';

let enabled = false;

// distinct_id de corrélation côté serveur (GUID du wizard). Stocké pour être
// injecté dans chaque event sans le passer manuellement à chaque appel.
let sessionGuid = null;

export function initPostHog() {
  const key = process.env.REACT_APP_POSTHOG_KEY;
  const host = process.env.REACT_APP_POSTHOG_HOST || 'https://eu.i.posthog.com';

  if (!key) {
    return; // non configuré -> no-op
  }

  posthog.init(key, {
    api_host: host,              // région EU (eu.i.posthog.com) — NE PAS mettre us
    autocapture: false,          // RGPD : pas de capture automatique des libellés/valeurs
    capture_pageview: false,     // SPA : pas de pageview auto
    capture_pageleave: false,
    // Session replay activé MAIS avec masquage strict : ce module affiche des PII
    // (nom/email/téléphone dans DataForm + récap). Tout champ saisi est masqué.
    disable_session_recording: false,
    session_recording: {
      maskAllInputs: true,       // masque TOUTES les saisies (nom, email, téléphone…)
      maskInputOptions: {        // ceinture + bretelles sur les types sensibles
        password: true,
        email: true,
        tel: true,
        text: true,
      },
    },
    person_profiles: 'identified_only', // visiteurs anonymes : pas de profil fantôme
  });

  enabled = true;
}

// À appeler une fois le GUID du wizard disponible. Ne crée PAS de profil
// (person_profiles=identified_only) : le GUID sert seulement de clé de
// corrélation avec le backend, transmis en property.
export function setSessionGuid(guid) {
  sessionGuid = guid;
}

// options : passé tel quel à posthog.capture. Sert notamment à envoyer un event
// au moment où l'utilisateur quitte la page : { transport: 'sendBeacon' }, sinon
// la requête XHR est annulée par le navigateur avant d'être partie.
export function track(event, properties, options) {
  if (!enabled) {
    return;
  }
  const payload = properties ? Object.assign({}, properties) : {};
  if (sessionGuid) {
    payload.devis_guid = sessionGuid;
  }
  posthog.capture(event, payload, options);
}
